import React from "react";
import ReactDOM from "react-dom/client";
import { ThemeProvider, CssBaseline } from "@mui/material";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter } from "react-router";
import dayjs from "dayjs";
import localizedFormat from "dayjs/plugin/localizedFormat.js";
import "dayjs/locale/en-au.js";

dayjs.extend(localizedFormat);
import { App } from "./App.js";
import { theme } from "./theme.js";
import { queryClient } from "./lib/queryClient.js";
import { installGlobalErrorReporting } from "./lib/reportError.js";

// Capture async / event-handler / unhandled-rejection errors (those React's
// ErrorBoundary can't see) and forward them to the backend → Telegram in prod.
installGlobalErrorReporting();

// Pin Australian formatting for every visitor, regardless of browser locale:
//  - dayjs().format('L')  → 25/04/2026
//  - dayjs().format('LL') → 25 April 2026
//  - dayjs().format('LLL') → 25 April 2026 3:30 PM
// ISO-style (YYYY-MM-DD) is unaffected; it's explicit.
dayjs.locale("en-au");

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <HelmetProvider>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <QueryClientProvider client={queryClient}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
          {import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} />}
        </QueryClientProvider>
      </ThemeProvider>
    </HelmetProvider>
  </React.StrictMode>,
);
